<div class="text-center m-auto mt-5">
  <rbb-loader/>
  <small class="text-secondary d-block">Formulargruppe wird geladen...</small>
</div>
